import { render, staticRenderFns } from "./UnitBBRSchema.vue?vue&type=template&id=2a5551aa&scoped=true&"
import script from "./UnitBBRSchema.vue?vue&type=script&lang=js&"
export * from "./UnitBBRSchema.vue?vue&type=script&lang=js&"
import style0 from "./UnitBBRSchema.vue?vue&type=style&index=0&id=2a5551aa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5551aa",
  null
  
)

export default component.exports